"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchNoConversionPaymentsArtifact = void 0;
const ContractArtifact_1 = require("../../ContractArtifact");
const _0_1_0_json_1 = require("./0.1.0.json");
exports.batchNoConversionPaymentsArtifact = new ContractArtifact_1.ContractArtifact({
    '0.1.0': {
        abi: _0_1_0_json_1.abi,
        deployment: {
            private: {
                address: '0x1411CB266FCEd1587b0AA29E9d5a9Ef3Db64A9C5',
                creationBlockNumber: 0,
            },
        },
    },
}, '0.1.0');
